export enum ExperiencesEndpointsEnum {
  EXPERIENCES = "/experiences",
}
